import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  }
};

const enhance = compose();

const FollowerTableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell sortDirection={orderBy === 'accountId' ? order : false}>
          <TableSortLabel
            active={orderBy === 'accountId'}
            direction={order}
            onClick={() => {
              onRequestSort('accountId', 'follower');
            }}
          >
            アカウントID
          </TableSortLabel>
        </TableCell>
        <TableCell sortDirection={orderBy === 'displayName' ? order : false}>
          <TableSortLabel
            active={orderBy === 'displayName'}
            direction={order}
            onClick={() => {
              onRequestSort('displayName', 'follower');
            }}
          >
            ユーザ名
          </TableSortLabel>
        </TableCell>
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(FollowerTableHead);
